import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link } from 'react-router-dom'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import StandardList from '../../common/listing/list.component.jsx'
import SideBar from '../../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../../common/spinner/loading.component.jsx'
import Icon from "../../common/icon/icon.component.jsx"

const messages = defineMessages({
    "default_name": {
        id: 'templates.default_template_name',
        defaultMessage: 'Default template',
    },
})
class EmailTemplatesListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            rows: [],
            headers: [],
            loading: false,
            templateKey: this.props.match.params.templateKey,
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        this.refreshSearch()
    }

    refreshSearch() {
        this.setState({
            loading: true,
        })
        AppContext.getApiClient().get('/templates/mail?templateKey=' + this.state.templateKey).then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
            })
        })

    }

    headers() {
        return [
            <FormattedMessage
                id="templates.list.headers.name_label"
                defaultMessage="Name"
            />,
            <FormattedMessage
                id="templates.list.headers.status_label"
                defaultMessage="Status"
            />,
            '',
        ]
    }

    row(item) {
        return [
            <Link to={"/settings/editEmailTemplatesById/" + item.id}>{item.attributes.name || this.props.intl.formatMessage(messages['default_name'])}</Link>,
            <span>{this.getStatusBadge(item.attributes.status)}</span>,
            <div>
                <Link to={"/settings/editEmailTemplatesById/" + item.id} className="btn btn-sm btn-outline-primary">
                    <FormattedMessage
                        id="templates.list.headers.edit_sections_btn"
                        defaultMessage="Edit content"
                    />
                </Link>
                {item.attributes.status !== 'default' &&
                    <button onClick={this.setDefault(item.id)} className="btn btn-sm btn-outline-primary ml-2">
                        <FormattedMessage
                            id="templates.list.headers.set_default_btn"
                            defaultMessage="Default"
                        />
                    </button>
                }
            </div>,
        ]
    }

    getStatusBadge(status) {
        switch (status) {
            case "enabled":
                return <div>
                    <div className="badge badge-primary">
                        <FormattedMessage
                            id="templates.list.status.enabled_label"
                            defaultMessage="Enabled"
                        />
                    </div>
                </div>
            case "disabled":
                return <div>
                    <div className="badge badge-secondary">
                        <FormattedMessage
                            id="templates.list.status.disabled_label"
                            defaultMessage="Disabled"
                        />
                    </div>
                </div>
            case "default":
                return <div>
                    <div className="badge badge-info">
                        <FormattedMessage
                            id="templates.list.status.default_label"
                            defaultMessage="Default"
                        />
                    </div>
                </div>
            default: return ""
        }
    }

    setDefault(templateId) {
        return function (e) {
            e.preventDefault()
            AppContext.getApiClient().patch('/templates/' + templateId + '/default').then(r => {
                setTimeout(() => {
                    this.refreshSearch()
                }, 500)
            })
        }.bind(this)
    }

    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        }
        return (
            <div>
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-9">
                                <Link to={"/branding"} className="btn btn-light">
                                    <Icon value={"chevron-left"} />
                                    <FormattedMessage
                                        id="templates.list.back_btn"
                                        defaultMessage="Back to branding"
                                    />
                                </Link>
                            </div>
                            <div className="col-3 text-align-right ">
                                <Link to={"/settings/editEmailTemplates/" + this.state.templateKey + "/new"} className="btn btn-primary">
                                    <Icon value={"plus-circle"} />
                                    <FormattedMessage
                                        id="templates.list.create_template_btn"
                                        defaultMessage="Create template"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {list}
            </div>
        );
    }
}

export default injectIntl(EmailTemplatesListing)


// WEBPACK FOOTER //
// ./src/settings/emails/templateslisting.component.jsx